var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLineChart = function SvgLineChart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m11.426 1.635-.14.06-.083.128-5.431 8.394-4.612 2.522a.5.5 0 0 0-.247.554.5.5 0 0 0 .537.382l5.723-.583.206-.02.13-.16 4.399-5.377 5.35-1.452a.5.5 0 1 0-.262-.965l-5.504 1.494-.155.042-.101.124-4.37 5.34-3.057.312 2.553-1.396.112-.061.068-.107 5.417-8.371 3.364-1.435a.5.5 0 0 0-.392-.92z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.285 15.59q0-.258.188-.445.187-.18.437-.18h16.172q.258 0 .445.18a.6.6 0 0 1 .188.445.6.6 0 0 1-.188.445.62.62 0 0 1-.445.18H.91a.61.61 0 0 1-.437-.18.6.6 0 0 1-.188-.445"
  })));
};
export default SvgLineChart;